var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary me-2",attrs:{"disabled":_vm.loading},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('div',{staticClass:"spinner-border text-success spinner-border-sm",attrs:{"role":"status"}},[_c('span',{staticClass:"visually-hidden"},[_vm._v("Loading...")])]):_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }